import { PlusOutlined } from "@ant-design/icons";
import { Modal, Upload } from "antd";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { patchRequest } from "../../axios";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const CompanyOnboardingLogo = ({
  setUploadFileProfilePic,
  fileList,
  setFileList,
  identifyProfileUrl,
  setIdentifyProfileUrl,
  beforeUpload
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [deleteFlag, setDeleteFlag] = useState(0);
  const { id } = useParams();
  const CompanyId = id ? atob(id) : null;
  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const handleChange = ({ fileList: newFileList }) => {
    const uploadedFile = newFileList[0]; // Assuming only one file is uploaded at a time
    if (uploadedFile && uploadedFile.originFileObj) {
      setUploadFileProfilePic(uploadedFile.originFileObj);
      setFileList(newFileList);
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload Logo
      </div>
    </button>
  );

  const handleRemove = async (file) => {
    if (CompanyId && deleteFlag === 0 && identifyProfileUrl !== null) {
      try {
        const apiResponse = await patchRequest(
          // `employee/${EmployeeId}/profile-photo-delete/`
          `company/${CompanyId}/company-logo-delete/`
        );
        console.log(apiResponse, "apiResponse");
        if (apiResponse.data.success) {
          // SuccessNotificationMsg(t("image_deleted_success"));
          setFileList([]);
          setDeleteFlag((deleteFlag) => deleteFlag + 1);
          setUploadFileProfilePic("");
          setIdentifyProfileUrl(null);
          // setFileName(null);
          // setSize(null);
        }
      } catch (error) {
        console.error("Error deleting image:", error);
        // Handle error appropriately (show message, retry, etc.)
      }
    } else {
      setFileList([]);
      setUploadFileProfilePic("");
      setIdentifyProfileUrl(null);
    }
  };
  // const beforeUpload = (file) => {
  //   const isJpgOrPng =
  //     file.type === "image/jpeg" ||
  //     file.type === "image/png" ||
  //     file.type === "image/jpg";
  //   if (!isJpgOrPng) {
  //     // message.error("You can only upload JPG/PNG file!");
  //     console.log(file.type, "not uploade wrong format");
  //   }
  //   return isJpgOrPng || Upload.LIST_IGNORE;
  // };
  return (
    <>
      <Upload
        // accept=".jpg, .png, .jpeg"
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        onRemove={handleRemove}
         beforeUpload={beforeUpload}
        accept=".jpg,.png"
        // beforeUpload={beforeUpload}
        // beforeUpload={() => false}
        
      >
        {fileList.length >= 1 ? null : uploadButton}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
};

CompanyOnboardingLogo.propTypes = {
  setUploadFileProfilePic: PropTypes.func.isRequired,
  fileList: PropTypes.array,
  setFileList: PropTypes.func.isRequired,
  identifyProfileUrl: PropTypes.func,
  setIdentifyProfileUrl: PropTypes.func,
  beforeUpload: PropTypes.func.isRequired
};

export default CompanyOnboardingLogo;
